import styled from 'styled-components';

import { ContainerProps } from './interface';

export const Container = styled.td<ContainerProps>`
  width: ${props => (props.width ? `${props.width}px !important` : 'auto')};

  padding: 1rem;
  font-size: 0.8rem;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  min-height: 50px;

  background: ${({ theme }) => theme.colors.GRID_HEAD_ITEM_BG};
  font-weight: 700;

  @media (max-width: 1600px) {
    font-size: 0.7rem;
    padding: 0.5rem;
  }

  &:first-child {
    border: none;
  }

  &:last-child {
  }

  div {
    float: left;
    width: 100%;
    display: flex;
    justify-content: space-between;

    input {
      background: rgba(0,0,0,0.02);
      border-radius: 5px;
      border: 1px solid rgba(0,0,0,0.2);
      height: 25px;
      margin: 0 5px 0 0;
      line-height: 25px;
      padding: 0 10px;
      font-size: 14px;
      font-weight: 700;
      text-decoration: underline;
    }

    button {
      background: none;
    }
  }

  strong {
    font-weight: 700;
  }

  span {
    margin: 0px;
    padding: 0px;
    flex: 1;
    cursor: pointer;
    text-decoration: ${props => (props.active ? 'underline' : 'normal')};
    color: ${({ theme }) => theme.colors.GRID_HEAD_ITEM_TEXT};
  }

  span:hover {
    text-decoration: underline;
  }

  i {
    margin: 0px;
    padding: 0px;
  }
`;
